import {Box} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import {v4 as uuid} from 'uuid';
import {useAppBar} from '../../../../components/appBar/appBarContext';
import CustomisedButton from '../../../../components/button/button';
import BoxInfoOtpInquiry from '../../../../components/otpInput/inquiry/boxInfoOtpInquiry';
import CustomisedOtpInput from '../../../../components/otpInput/otpInput';
import OtpSkeleton from '../../../../components/otpInput/otpSkeleton';
import {
    INQUIRY_REQUIRED_OTP,
    INQUIRY_RESULT,
} from '../../../../config/cacheKey';
import {ApiResultModel} from '../../../../models/common.model';
import {
    IInquiryResponse,
    IInquiryResult,
    TotalInquiryRequest,
} from '../../../../models/inquiry.model';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {getTokenClaims} from '../../../../services/auth.service';
import {TotalInquiry} from '../../../../services/inquiry.service';
import {IInquiry} from '../IInquriry';
export default function InquiryOtp({
    setInnerState,
    setStep,
    referenceKey,
}: IInquiry) {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);
    const queryClient = useQueryClient();
    const [inquiryRequiredOtp, setInquiryRequiredOtp] = useState(
        queryClient.getQueryData(INQUIRY_REQUIRED_OTP) as IInquiryResult
    );
    const dispatch = useDispatch();

    // const otpLenght = 5;
    const mobile = getTokenClaims()?.phoneNumber;
    const randomKeyForDispatch = Math.random();
    const {setHeader} = useAppBar();

    useEffect(() => {
        const msg =
            inquiryRequiredOtp?.inquiryType == 1 ||
            inquiryRequiredOtp?.inquiryType == 3
                ? 'استعلام چک برگشتی و معوقات بانکی'
                : inquiryRequiredOtp?.inquiryType == 5
                  ? 'استعلام رتبه اعتباری بانکی'
                  : 'استعلام';
        setHeader(msg, 'otp');
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({
                prevInnerState: `inquiry ${randomKeyForDispatch}`,
            })
        );
    }, []);

    function handleBtnClick(values: string) {
        const request = {} as TotalInquiryRequest;
        request.otp = values;
        request.referenceKey = referenceKey!;
        request.otpInquiryType = inquiryRequiredOtp?.inquiryType;
        request.otpReference = inquiryRequiredOtp?.inquiryOtpReference;

        InquiryValidationOTPMutation(request);
    }
    const {mutateAsync: InquiryValidationOTPMutation, isLoading} = useMutation(
        TotalInquiry,
        {
            onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
                if (data.isSuccess) {
                    if (data.data) {
                        setError(false);
                        if (data.data.requiredOtpValidation) {
                            setInnerState!('otp');
                            queryClient.setQueryData(
                                INQUIRY_REQUIRED_OTP,
                                data.data.requiredOtpValidation
                            );
                            setInquiryRequiredOtp(
                                data.data.requiredOtpValidation
                            );
                            setOtp('');
                        } else if (data.data.inquiries.length > 0) {
                            setInnerState!('inquiryResult');
                            queryClient.setQueryData(
                                INQUIRY_RESULT,
                                data.data.inquiries
                            );
                        } else {
                            setStep(uuid);
                        }
                    }
                } else {
                    setOtp('');
                    setError(true);
                }
            },
            onError: () => {},
        }
    );
    if (isLoading) {
        return <OtpSkeleton />;
    }
    const titleBouncedCheque = (
        <span className="text-[var(--primary-text-color)]">
            کد دسترسی برای{' '}
            <span className="secondaryColorLight-600 ">
                استعلام چک برگشتی و معوقات بانکی
            </span>{' '}
            به شماره همراه <span className="yekanBakhFaNum">{mobile}</span>{' '}
            ارسال شده است.
        </span>
    );
    const titleCredit = (
        <span className="text-[var(--primary-text-color)]">
            کد دسترسی برای{' '}
            <span className="secondaryColorLight-600 ">
                استعلام رتبه اعتباری بانکی
            </span>{' '}
            به شماره همراه <span className="yekanBakhFaNum">{mobile}</span>{' '}
            ارسال شده است.
        </span>
    );

    return (
        <div className="container-height-drawer">
            <Box className="content-container">
                <div className="drawer-content">
                    <div className="!pb-4 ">
                        <BoxInfoOtpInquiry
                            title={inquiryRequiredOtp?.inquiryTypeTitle ?? ''}
                        />
                    </div>

                    <div className="mt-4">
                        <CustomisedOtpInput
                            resendOtp={() => handleBtnClick(otp)}
                            otp={otp}
                            otpTime={
                                inquiryRequiredOtp?.otpExpirationMilliSecond
                            }
                            setOtp={setOtp}
                            numInputs={inquiryRequiredOtp?.otpLength ?? 5}
                            error={error}
                        />
                    </div>
                </div>
                <Box className="py-5">
                    <CustomisedButton
                        title="ثبت و ادامه"
                        disable={
                            otp.length < (inquiryRequiredOtp?.otpLength ?? 5)
                        }
                        onClick={() => handleBtnClick(otp)}
                        type="button"
                    />
                </Box>
                {/* <div
                className="text-center primaryColorLight-900 "
                style={{ marginTop: '30px', fontSize: '14px' }}
            >
                کد تایید را دریافت نکرده اید؟
            </div> */}
            </Box>
        </div>
    );
}
